import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { BASE_URL, FORMAT_COMMON_ID } from "../../utils/EmpUtil";
import { is401 } from "../../errors/ErrorConstants";

class DeliveryRangesClient {
  static baseUrl = BASE_URL;

  static getDeliveryRanges() {
    const url = `${this.baseUrl}/nsc/deliveryRanges`;
    return axios
      .get(url, getHeaders())
      .then((response) => response.data.result.nscDeliveryRanges)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static async saveDeliveryRanges(data) {
    const url = `${this.baseUrl}/nsc/deliveryRanges`;
    return await axios
      .post(url, data, getHeaders())
      .then((response) => response.status)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static async getDealerDeliveryRanges(user) {
    const url = `${
      this.baseUrl
    }/dealer/deliveryRanges?dealerCommonId=${FORMAT_COMMON_ID(user.commonId)}`;

    return await axios
      .get(url, getHeaders())
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static async saveDealerDeliveryRanges(data, user, commonIds) {
    const url = `${this.baseUrl}/dealer/deliveryRanges?dealerCommonIds=${commonIds}`;
    await axios.post(url, data, getHeaders());
  }
}

export default DeliveryRangesClient;
